import modelNameRenderer from './modelNameRenderer';

export default modelNameRenderer;
